import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { langSupported } from '../../../../../core/consts/const';
import { I18nDetectorService } from '../../../../../core/services/i18n.detector.service';
import { environment } from '../../../../../../environments/environment';
import { TranslateService } from '../../../../../shared/modules/translate/translate.service';

@Component({
  selector: '[app-footer-languages]',
  imports: [InlineSVGModule, RouterModule],
  templateUrl: './footer-languages.component.html',
  styleUrl: './footer-languages.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLanguagesComponent implements OnInit {
  ar_link = signal('');
  en_link = signal('');
  es_link = signal('');
  hi_link = signal('');
  zh_link = signal('');
  bn_link = signal('');
  pt_link = signal('');
  fr_link = signal('');
  ru_link = signal('');
  ur_link = signal('');

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public i18nService: I18nDetectorService,
    //public translationService: TranslateService,
  ) { }

  ngOnInit() {
    //if(this.pt.isServer) return
    this.reBuildAll();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //  this.translationService.reLoadLanguage();
        this.reBuildAll();
      }
    });
  }

  reBuildAll() {
    this.en_link.set(this.buildLink('en'));
    this.es_link.set(this.buildLink('es'));
    this.hi_link.set(this.buildLink('hi'));
    this.zh_link.set(this.buildLink('zh'));
    this.bn_link.set(this.buildLink('bn'));
    this.pt_link.set(this.buildLink('pt'));
    this.fr_link.set(this.buildLink('fr'));
    this.ru_link.set(this.buildLink('ru'));
    this.ur_link.set(this.buildLink('ur'));
    this.ar_link.set(this.buildLink('ar'));
  }
  buildLink(lang: string) {
    const links = this.document.location.pathname
      .split('/')
      .filter((c) => !langSupported.some((v) => v == c) && c != '');

    return (
      environment.front.href +
      '/' +
      lang +
      (links.length ? '/' + links.join('/') : '')
    );
  }
}
